"use client";

import {
  createContext,
  useContext,
  ReactNode,
} from "react";

export type APIBackend = {
  Slug?: string | null;
  Adresse?: string | null;
  Email?: string | null;
  Telephone?: string | null;
  Schedule?: string | null;
  Location?: string | number[] | null;
};

type AgencyContextType = {
  apiBackend: APIBackend | null;
};

const AgencyContext =
  createContext<AgencyContextType | null>(null);

type Props = {
  children: ReactNode;
  apiBackend: APIBackend | null;
};

export function AgencyProvider({
  children,
  apiBackend,
}: Props) {
  return (
    <AgencyContext.Provider
      value={{
        apiBackend,
      }}
    >
      {children}
    </AgencyContext.Provider>
  );
}

export function useAgency() {
  const context =
    useContext(AgencyContext);

  if (!context) {
    throw new Error(
      "useAgency doit être utilisé dans AgencyProvider"
    );
  }

  return context;
}